module.exports = __webpack_public_path__ + "static/media/GrassGreenTexture_1024_normal.ce43156e.jpg";